/**
 * @ignore
 * Created by !daletan on 2/30/93.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const intelligentFormatObj = require('dibs-currency-helpers/intelligentFormatObj');
const getCurrencySymbol = require('dibs-currency-helpers/getCurrencySymbol');
const copy = require('../../constants/contactDealerCopy.json');
const HoldRequestInput = require('./HoldRequestInput').default;

class ContactDealerMessage extends React.Component {
    constructor() {
        super();
        this.state = { name: '' };
        this.onNameInput = this.onNameInput.bind(this);
    }

    onNameInput(e) {
        this.setState({ name: e.target.value });
    }

    render() {
        const { name } = this.state;
        const {
            offerExpanded,
            price,
            currency,
            isLoggedIn,
            onNameEntered,
            onMessageFocused,
            onMessageInput,
            nameError,
            onMessageEntered,
            messageError,
            phoneError,
            trackedPhoneNumber,
            displayOffer,
            onOfferClick,
            onOfferBlurred,
            onOfferEntered,
            offerAmount,
            error,
            isDealerMessageSending,
            onContactDealer,
            type,
            showRequestHold,
            isHoldRequestChecked,
            onHoldRequestClick,
            isRemoveContactDealerCTATestRunning,
        } = this.props;
        const offerClasses = classNames('pdp-make-offer-wrapper', { expanded: offerExpanded });
        const offerLinkClasses = classNames('pdp-dealer-link', { 'offer-link': !offerExpanded });
        const symbol = offerExpanded ? '–' : '+';
        const { currencySymbol, number } = intelligentFormatObj(price, currency);

        let buttonText = isRemoveContactDealerCTATestRunning ? 'Send Message' : 'Send';

        const placeholderText = isRemoveContactDealerCTATestRunning
            ? 'Let us know how we can help you.'
            : `Contact the ${
                  type
              } to learn more about the history of the piece, request more details or even to discuss the price.`;

        const rowCount = isRemoveContactDealerCTATestRunning ? 8 : 5;

        let content = null;

        if (isRemoveContactDealerCTATestRunning) {
            content = (
                <p className="pdp-dealer-trade-test-info">
                    <span className="pdp-dealer-trade-test-title pdp-dealer-trade-test-contact-title">
                        Send Us a Message
                    </span>
                </p>
            );
        } else {
            content = (
                <div>
                    {!isLoggedIn && (
                        <div className="pdp-contact-name-wrapper">
                            <input
                                className="pdp-contact-name com-form-input"
                                onBlur={onNameEntered}
                                onFocus={onMessageFocused}
                                onChange={this.onNameInput}
                                value={name}
                            />
                            <span className="input-placeholder">Name</span>
                            {nameError && (
                                <p className="pdp-contact-errors">{copy.errors.isRequired}</p>
                            )}
                        </div>
                    )}
                </div>
            );
        }

        return (
            <div className="pdp-dealer-section pdp-contact-dealer">
                {content}
                <textarea
                    name="dealerMessage"
                    className="pdp-contact-text"
                    onBlur={onMessageEntered}
                    onFocus={onMessageFocused}
                    placeholder={placeholderText}
                    onChange={onMessageInput}
                    rows={rowCount}
                />
                {messageError && <p className="pdp-contact-errors">{copy.errors.isRequired}</p>}
                {phoneError && (
                    <p className="pdp-contact-errors">
                        {trackedPhoneNumber
                            ? `${copy.errors.dealerPhone} ${trackedPhoneNumber}.`
                            : copy.errors.supportPhone}
                    </p>
                )}
                {displayOffer && (
                    <p className={offerLinkClasses} onClick={onOfferClick}>{`Make an Offer ${
                        symbol
                    }`}</p>
                )}
                {displayOffer && (
                    <div className={offerClasses}>
                        <p className="pdp-contact-item-price">{`List Price ${currencySymbol}${
                            number
                        }`}</p>
                        <div className="pdp-contact-offer-wrapper">
                            <span className="pdp-contact-offer-currency">
                                {getCurrencySymbol(currency)}
                            </span>
                            <input
                                className="pdp-contact-offer com-form-input"
                                onBlur={onOfferBlurred}
                                onChange={onOfferEntered}
                                value={offerAmount}
                            />
                        </div>
                        <p className="pdp-contact-errors">{error}</p>
                    </div>
                )}
                {showRequestHold && (
                    <HoldRequestInput
                        isHoldRequestChecked={isHoldRequestChecked}
                        onClick={onHoldRequestClick}
                    />
                )}
                <button
                    className="button-large button-primary pdp-contact-button"
                    disabled={isDealerMessageSending}
                    onClick={onContactDealer}
                >
                    {buttonText}
                </button>
            </div>
        );
    }
}

ContactDealerMessage.defaultProps = {
    displayOffer: false,
    offerAmount: '',
    onMessageInput() {},
    phoneError: false,
};

ContactDealerMessage.propTypes = {
    currency: PropTypes.string.isRequired,
    error: PropTypes.string,
    isDealerMessageSending: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    displayOffer: PropTypes.bool,
    hasErrors: PropTypes.bool,
    messageError: PropTypes.bool,
    nameError: PropTypes.bool,
    phoneError: PropTypes.bool,
    trackedPhoneNumber: PropTypes.string,
    offerAmount: PropTypes.string,
    offerExpanded: PropTypes.bool.isRequired,
    onContactDealer: PropTypes.func.isRequired,
    onMessageEntered: PropTypes.func.isRequired,
    onMessageFocused: PropTypes.func.isRequired,
    onMessageInput: PropTypes.func,
    onNameEntered: PropTypes.func.isRequired,
    onOfferBlurred: PropTypes.func.isRequired,
    onOfferClick: PropTypes.func.isRequired,
    onOfferEntered: PropTypes.func.isRequired,
    price: PropTypes.number,
    type: PropTypes.string.isRequired,
    showRequestHold: PropTypes.bool,
    isHoldRequestChecked: PropTypes.bool,
    onHoldRequestClick: PropTypes.func,
    isRemoveContactDealerCTATestRunning: PropTypes.bool,
};

module.exports = ContactDealerMessage;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/ContactDealerMessage.jsx